import React, { useRef } from 'react';
import clsx from 'clsx';
import { Button } from 'acq-components/lib/base-components/Button/Button';
import { scrollToElementTween } from 'service_modules/utils/window-onscroll';
import { getWinWidth } from 'core_modules/bootstrap/browsers/browser-detection';
import replaceStringWithVars from 'src/universal/utils/replaceStringWithVars';
import { sendDTMClickEvent } from 'service_modules/models/dtm-tagging';
import secondaryStyles from 'acq-components/lib/base-components/Button/styles/intl-commercial/secondary.scss?modules';
import styles from './__styles__/stickyBar.scss?modules';

const StickyBar = React.memo(({ content = [], launchForm = () => {} }) => {
  const wrapElement = useRef(null);
  const phoneCtaList = ['requestACallButton'];
  const getLinks = () =>
    content.filter(linkItem => phoneCtaList.includes(linkItem.key));
  const mobileDtmList = content.filter((linkItem = {}) =>
    linkItem.key.endsWith('Mobile')
  );
  const createButtonHandler = (mobileDtm = {}, callback) => {
    return () => {
      if (typeof callback === 'function') {
        callback();
        scrollToElementTween(wrapElement.current.parentElement, {
          align: {
            topOffset: 50
          }
        });
      }

      const dtmObj = {
        ...mobileDtm,
        eventAsset: replaceStringWithVars({
          varsObject: {
            deviceType: getWinWidth() <= 768 ? 'mobile' : 'tablet'
          },
          string: mobileDtm.eventAsset
        })
      };

      sendDTMClickEvent(dtmObj);
    };
  };

  return (
    <div ref={wrapElement} className={styles.stickyContainer}>
      {getLinks().map((item, idx) => {
        const callback = item.key === 'requestACallButton' ? launchForm : undefined;
        const mobileLink = mobileDtmList[idx] || {};
        return (
          <Button
            key={idx}
            className={clsx(secondaryStyles.secondaryButton, styles[item.key])}
            onClick={createButtonHandler(mobileLink.dtm, callback)}
            href={item.url}
            Component={item.type === 'link' ? 'a' : undefined}
          >
            {item.title}
          </Button>
        );
      })}
    </div>
  );
});

export { StickyBar };
